// ══════════════════════════════════════════════════════════
// CENTOVA METADATA SERVICE
//
// Consulta el metadata del stream oficial de CentovaCast
// a través de la Edge Function get-centova-metadata.
//
// La Edge Function proxy-request al servidor CentovaCast
// y devuelve canción, artista, oyentes y estado.
// ══════════════════════════════════════════════════════════

import { getSupabaseClient } from '@/services/supabase/client';

export interface CentovaMetadata {
  song: string | null;
  artist: string | null;
  title: string | null;
  listeners: number;
  status: 'online' | 'offline' | 'error';
  raw_song: string | null;
  fetched_at: string;
}

/**
 * Obtiene el metadata actual del stream de CentovaCast
 * a través de la Edge Function de Supabase.
 *
 * La Edge Function consulta el servidor CentovaCast real
 * y devuelve la metadata parseada.
 *
 * En caso de error de red o timeout, retorna un objeto
 * con status 'error' y datos nulos.
 */
export async function fetchCentovaMetadata(): Promise<CentovaMetadata> {
  try {
    const client = getSupabaseClient();

    const { data, error } = await client.functions.invoke<CentovaMetadata>(
      'get-centova-metadata',
    );

    if (error) {
      console.warn('[centovaMetadata] Edge function error:', error.message);
      return {
        song: null,
        artist: null,
        title: null,
        listeners: 0,
        status: 'error',
        raw_song: null,
        fetched_at: new Date().toISOString(),
      };
    }

    return data ?? {
      song: null,
      artist: null,
      title: null,
      listeners: 0,
      status: 'offline',
      raw_song: null,
      fetched_at: new Date().toISOString(),
    };
  } catch (err) {
    console.warn('[centovaMetadata] Fetch error:', err);
    return {
      song: null,
      artist: null,
      title: null,
      listeners: 0,
      status: 'error',
      raw_song: null,
      fetched_at: new Date().toISOString(),
    };
  }
}